import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {ItemObject} from '@PosterWhiteboard/items/item/item.types';

export function useGetKeyFromActiveItem<T extends keyof ItemObject>(key: T): ItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const currentPageId = state.posterEditor.currentPageId;

    const itemObject = state.posterEditor.posterObject?.pages.pagesHashMap[currentPageId]?.items.itemsHashMap[activeItemId];

    if (itemObject?.[key] !== undefined) {
      return itemObject[key];
    }

    return undefined;
  });
}
